import { Component, Output, EventEmitter } from '@angular/core';
import { TutorialService } from 'src/app/services/tutorial.service';

@Component({
  selector: 'app-tutorial-panel',
  templateUrl: './tutorial-panel.component.html',
  styleUrls: ['./tutorial-panel.component.scss']
})
export class TutorialPanelComponent {
  
  @Output() actionClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  constructor(public tutorialService: TutorialService) {}

  runTutorialStepAction() {
    this.actionClicked.emit();
  }

  onDashboardControllerGadgetChanged(gadgetId: string) {
    this.tutorialService.selectDashboardControllerGadget(gadgetId);
  }

  cancelTutorial() {
    this.closeClicked.emit();
  }
}
